import parseUrl from '@/core/helpers/parseUrl'

export default {
  downloadBundle({ rootState }, fileIDs) {
    const token = rootState.auth.authToken
    const url = parseUrl(process.env.SERVICES_URL + '/download?fileIDs&token', { fileIDs, token })
    window.open(url)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/file/actions.js